<div class="section">
    <div data-qa-id="locums-rec-controlled-substances-header" class="nova__label">{{ title }}</div>
    <div data-qa-id="locums-rec-controlled-substances-value">
        <label *ngIf="controlledSubstances?.length === 0" data-qa-id="locums-rec-controlled-substances-dash">-</label>
        <div class="jd__section__container" *ngIf="controlledSubstances?.length > 0">
            <ng-container *ngFor=" let controlledSubstance of controlledSubstances; let i=index">
                <label [attr.data-qa-id]="'locums-rec-controlled-substances-label-' + i">
                    {{ controlledSubstance.name }}
                </label>
                <label class="jd__section__emphasized" [attr.data-qa-id]="'locums-rec-controlled-substances-required-' + i">
                    Required
                </label>
            </ng-container>
        </div>
    </div>
</div>